
import React from 'react';
import { type User as UserType } from '@/types/userRole';
import { Award } from 'lucide-react';

interface WelcomeSectionProps {
  user: UserType;
  formattedDate: string;
  points: number;
}

const WelcomeSection: React.FC<WelcomeSectionProps> = ({ user, formattedDate, points }) => {
  return (
    <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-8 mb-8 text-white shadow-lg">
      <div className="flex items-center space-x-4">
        <div className="bg-white/10 p-3 rounded-lg backdrop-blur-sm">
          {user.avatar ? (
            <img 
              src={user.avatar} 
              alt={user.name} 
              className="h-12 w-12 rounded-full"
            />
          ) : (
            <div className="h-12 w-12 rounded-full bg-white/20 flex items-center justify-center text-xl font-semibold">
              {user.name.charAt(0)}
            </div>
          )}
        </div>
        <div>
          <h2 className="text-2xl font-bold mb-1">Welcome back, {user.name}!</h2>
          <div className="flex items-center space-x-2 text-blue-100">
            <p>Member since {formattedDate}</p>
            <span className="text-blue-200">•</span>
            <div className="flex items-center">
              <Award className="h-4 w-4 mr-1" />
              <span>{points.toLocaleString()} points</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeSection;
